export const cmsDefault = [
  {
    key: "ptc_list_citytown",
    value: {
      microContentValue: "City/Town",
    },
  },
  {
    key: "ptc_list_failure",
    value: {
      microContentValue: "Failed to unsubscribe",
    },
  },
  {
    key: "ptc_list_removal_a_state",
    value: {
      microContentValue: "Please select a state",
    },
  },
  {
    key: "ptc_list_removal_address_notfound",
    value: {
      microContentValue: "We didn't find a verified address for your entry",
    },
  },
  {
    key: "ptc_list_removal_email_address",
    value: {
      microContentValue: "Invalid Email Address",
    },
  },
  {
    key: "ptc_list_removal_empty_city",
    value: {
      microContentValue: "Empty City",
    },
  },
  {
    key: "ptc_list_removal_empty_first_name",
    value: {
      microContentValue: "Empty First Name",
    },
  },
  {
    key: "ptc_list_removal_empty_last_name",
    value: {
      microContentValue: "Empty Last Name",
    },
  },
  {
    key: "ptc_list_removal_first_name",
    value: {
      microContentValue: "Please enter your first name",
    },
  },
  {
    key: "ptc_list_removal_original_address",
    value: {
      microContentValue: "Use Original Address",
    },
  },
  {
    key: "ptc_list_removal_post_mail_comm",
    value: {
      microContentValue:
        "You have opted out of all Dell &amp; Dell EMC marketing postal mail communications.",
    },
  },
  {
    key: "ptc_list_removal_select_state",
    value: {
      microContentValue: "Select State",
    },
  },
  {
    key: "ptc_list_removal_street_address",
    value: {
      microContentValue: "Please enter your street address",
    },
  },
  {
    key: "ptc_list_removal_this_address",
    value: {
      microContentValue: "Use This Address",
    },
  },
  {
    key: "ptc_list_removal_validation_unsubscribe",
    value: {
      microContentValue: "You have successfully unsubscribed.",
    },
  },
  {
    key: "ptc_list_removal_verified_address",
    value: {
      microContentValue: "Verified Addresses",
    },
  },
  {
    key: "ptc_list_removal_your_city",
    value: {
      microContentValue: "Please enter your city",
    },
  },
  {
    key: "ptc_list_removal_your_entry",
    value: {
      microContentValue: "Your Entry",
    },
  },
  {
    key: "ptc_list_removal_zip_code",
    value: {
      microContentValue: "Please enter a valid zip code",
    },
  },
  {
    key: "ptc_list_state_lbl",
    value: {
      microContentValue: "State/Province/Region",
    },
  },
  {
    key: "ptc_list_validate_email",
    value: {
      microContentValue: "Please enter a valid email address",
    },
  },
  {
    key: "ptc_list_validate_fax",
    value: {
      microContentValue: "Please enter a valid fax number",
    },
  },
  {
    key: "ptc_list_validate_fname",
    value: {
      microContentValue: "Please enter a valid first name",
    },
  },
  {
    key: "ptc_list_validate_home",
    value: {
      microContentValue: "Please enter a valid home number",
    },
  },
  {
    key: "ptc_list_validate_homephone",
    value: {
      microContentValue: "Please enter a valid home phone number",
    },
  },
  {
    key: "ptc_list_validate_lastname",
    value: {
      microContentValue: "Please enter your last name",
    },
  },
  {
    key: "ptc_list_validate_mobile",
    value: {
      microContentValue: "Please enter a valid mobile number",
    },
  },
  {
    key: "ptc_list_validate_phone",
    value: {
      microContentValue: "Please enter a valid phone number",
    },
  },
  {
    key: "ptc_list_validate_state",
    value: {
      microContentValue: "Please enter your State/Province/Region",
    },
  },
  {
    key: "ptc_list_validate_street",
    value: {
      microContentValue: "Please enter a valid street address",
    },
  },
  {
    key: "ptc_list_zipcode",
    value: {
      microContentValue: "ZIP/Postal Code",
    },
  },
  {
    key: "ptc_lst_countries",
    value: {
      microContentValue:
        '[<br />{<br />"Value": "Saudi Arabia",<br />"Code": "SA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "St. Lucia",<br />"Code": "LC",<br />"Region": "US"<br />},<br />{<br />"Value": "Ethiopia",<br />"Code": "ET",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Tonga",<br />"Code": "TO",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Greece",<br />"Code": "GR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Swaziland",<br />"Code": "SZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "CIS",<br />"Code": "RS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bhutan",<br />"Code": "BT",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Serbia",<br />"Code": "YU",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Guinea",<br />"Code": "GN",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Solomon Island",<br />"Code": "SB",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Guadeloupe",<br />"Code": "GP",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Martinique",<br />"Code": "MQ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Germany",<br />"Code": "DE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Reunion",<br />"Code": "RE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Palau",<br />"Code": "PW",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Iceland",<br />"Code": "IS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Niger",<br />"Code": "NE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Egypt",<br />"Code": "EG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "South Africa",<br />"Code": "ZA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "China",<br />"Code": "CN",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Democratic Republic of the Congo",<br />"Code": "CD",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Emerging Countries ",<br />"Code": "ED",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "St. Vincent &amp; Grenadines",<br />"Code": "VC",<br />"Region": "US"<br />},<br />{<br />"Value": "New Caledonia",<br />"Code": "NC",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "India",<br />"Code": "IN",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Slovenia",<br />"Code": "SI",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Suriname",<br />"Code": "SR",<br />"Region": "US"<br />},<br />{<br />"Value": "St. Kitts &amp; Nevis",<br />"Code": "KN",<br />"Region": "US"<br />},<br />{<br />"Value": "Slovakia",<br />"Code": "SK",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bangladesh",<br />"Code": "BD",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Namibia",<br />"Code": "NA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Russia",<br />"Code": "RU",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Fiji",<br />"Code": "FJ",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Belize",<br />"Code": "BZ",<br />"Region": "US"<br />},<br />{<br />"Value": "Canada",<br />"Code": "CA",<br />"Region": "US"<br />},<br />{<br />"Value": "Uruguay",<br />"Code": "UY",<br />"Region": "US"<br />},<br />{<br />"Value": "Andorra",<br />"Code": "AD",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Ukraine",<br />"Code": "UA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "United States",<br />"Code": "US",<br />"Region": "US"<br />},<br />{<br />"Value": "Guinea Bissau",<br />"Code": "GW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bahamas",<br />"Code": "BS",<br />"Region": "US"<br />},<br />{<br />"Value": "Estonia",<br />"Code": "EE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Papua New Guinea",<br />"Code": "PG",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Argentina",<br />"Code": "AR",<br />"Region": "US"<br />},<br />{<br />"Value": "Togo",<br />"Code": "TG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Tunisia",<br />"Code": "TN",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Northern Marianas Island",<br />"Code": "MP",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Switzerland",<br />"Code": "CH",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Puerto Rico",<br />"Code": "PR",<br />"Region": "US"<br />},<br />{<br />"Value": "Finland",<br />"Code": "FI",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Mauritius",<br />"Code": "MU",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "United Kingdom",<br />"Code": "UK",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Vanuatu",<br />"Code": "VU",<br />"Region": "APJ"<br />},<br />{<br />"Value": "East Timor",<br />"Code": "TL",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Somalia",<br />"Code": "SO",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Brunei",<br />"Code": "BN",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Yemen",<br />"Code": "YE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Kosovo",<br />"Code": "KV",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Algeria",<br />"Code": "DZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Middle East",<br />"Code": "AE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Dominica",<br />"Code": "DM",<br />"Region": "US"<br />},<br />{<br />"Value": "Ghana",<br />"Code": "GH",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Czech Republic",<br />"Code": "CZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Cape Verde",<br />"Code": "CV",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Montenegro",<br />"Code": "CS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Rwanda",<br />"Code": "RW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Malawi",<br />"Code": "MW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bolivia",<br />"Code": "BO",<br />"Region": "US"<br />},<br />{<br />"Value": "US Virgin Islands",<br />"Code": "VI",<br />"Region": "US"<br />},<br />{<br />"Value": "British Virgin Islands",<br />"Code": "VG",<br />"Region": "US"<br />},<br />{<br />"Value": "Seychelles",<br />"Code": "SC",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Spain",<br />"Code": "ES",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Eritrea",<br />"Code": "ER",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Costa Rica",<br />"Code": "CR",<br />"Region": "US"<br />},<br />{<br />"Value": "Mongolia",<br />"Code": "MN",<br />"Region": "APJ"<br />},<br />{<br />"Value": "French Overseas Territories",<br />"Code": "TF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Zimbabwe",<br />"Code": "ZW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Thailand",<br />"Code": "TH",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Burkina Faso",<br />"Code": "BF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Central African Republic",<br />"Code": "CF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Cook Islands",<br />"Code": "CK",<br />"Region": "APJ"<br />},<br />{<br />"Value": "United Arab Emirates",<br />"Code": "AE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Guyana",<br />"Code": "GY",<br />"Region": "US"<br />},<br />{<br />"Value": "New Zealand",<br />"Code": "NZ",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Indonesia",<br />"Code": "ID",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Africa",<br />"Code": "AA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Israel",<br />"Code": "IL",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Hong Kong",<br />"Code": "HK",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Chad",<br />"Code": "TD",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Ireland",<br />"Code": "IE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Kazakhstan",<br />"Code": "KZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Denmark",<br />"Code": "DK",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Afghanistan",<br />"Code": "AF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Singapore",<br />"Code": "SG",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Turkmenistan",<br />"Code": "TM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Jamaica",<br />"Code": "JM",<br />"Region": "US"<br />},<br />{<br />"Value": "Sierra Leone",<br />"Code": "SL",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Venezuela",<br />"Code": "VE",<br />"Region": "US"<br />},<br />{<br />"Value": "Guatemala",<br />"Code": "GT",<br />"Region": "US"<br />},<br />{<br />"Value": "French Guiana",<br />"Code": "GF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Latvia",<br />"Code": "LV",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Kuwait",<br />"Code": "KW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Cambodia",<br />"Code": "KH",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Mayotte",<br />"Code": "YT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Antigua &amp; Barbuda",<br />"Code": "AG",<br />"Region": "US"<br />},<br />{<br />"Value": "Pakistan",<br />"Code": "PK",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Gambia",<br />"Code": "GM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Cameroon",<br />"Code": "CM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Belarus",<br />"Code": "BY",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Djibouti",<br />"Code": "DJ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Lithuania",<br />"Code": "LT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Guam",<br />"Code": "GU",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Zambia",<br />"Code": "ZM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Tuvalu",<br />"Code": "TV",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Morocco",<br />"Code": "MA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Albania",<br />"Code": "AL",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Sweden",<br />"Code": "SE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "El Salvador",<br />"Code": "SV",<br />"Region": "US"<br />},<br />{<br />"Value": "Mozambique",<br />"Code": "MZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Montserrat",<br />"Code": "MS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Commonweath of Russian States",<br />"Code": "RS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Haiti",<br />"Code": "HT",<br />"Region": "US"<br />},<br />{<br />"Value": "Christmas Island",<br />"Code": "CX",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Croatia",<br />"Code": "HR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Vietnam",<br />"Code": "VN",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Peru",<br />"Code": "PE",<br />"Region": "US"<br />},<br />{<br />"Value": "Lesotho",<br />"Code": "LS",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Angola",<br />"Code": "AO",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Australia",<br />"Code": "AU",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Trinidad &amp; Tobago",<br />"Code": "TT",<br />"Region": "US"<br />},<br />{<br />"Value": "Qatar",<br />"Code": "QA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Equatorial Guinea",<br />"Code": "GQ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Barbados",<br />"Code": "BB",<br />"Region": "US"<br />},<br />{<br />"Value": "Hungary",<br />"Code": "HU",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Kenya",<br />"Code": "KE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Paraguay",<br />"Code": "PY",<br />"Region": "US"<br />},<br />{<br />"Value": "Bermuda",<br />"Code": "BM",<br />"Region": "US"<br />},<br />{<br />"Value": "Sri Lanka",<br />"Code": "LK",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Comoros",<br />"Code": "KM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Colombia",<br />"Code": "CO",<br />"Region": "US"<br />},<br />{<br />"Value": "Dominican Republic",<br />"Code": "DO",<br />"Region": "US"<br />},<br />{<br />"Value": "Mali",<br />"Code": "ML",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Turkey",<br />"Code": "TR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Ivory Coast",<br />"Code": "CI",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Italy",<br />"Code": "IT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Korea",<br />"Code": "KR",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Nauru",<br />"Code": "NR",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Myanmar",<br />"Code": "MM",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Norway",<br />"Code": "NO",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Philippines",<br />"Code": "PH",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Armenia",<br />"Code": "AM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Georgia",<br />"Code": "GE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Belgium",<br />"Code": "BE",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Ecuador",<br />"Code": "EC",<br />"Region": "US"<br />},<br />{<br />"Value": "Luxembourg",<br />"Code": "LU",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Turks &amp; Caicos Islands",<br />"Code": "TC",<br />"Region": "US"<br />},<br />{<br />"Value": "Netherlands",<br />"Code": "NL",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Congo",<br />"Code": "CG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Anguilla",<br />"Code": "AI",<br />"Region": "US"<br />},<br />{<br />"Value": "Romania",<br />"Code": "RO",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Benin",<br />"Code": "BJ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Azerbaijan",<br />"Code": "AZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Mauritania",<br />"Code": "MR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bulgaria",<br />"Code": "BG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Nicaragua",<br />"Code": "NI",<br />"Region": "US"<br />},<br />{<br />"Value": "Asia Pacific",<br />"Code": "AP",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Aruba",<br />"Code": "AW",<br />"Region": "US"<br />},<br />{<br />"Value": "Botswana",<br />"Code": "BW",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Kiribati",<br />"Code": "KI",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Kyrgyzstan",<br />"Code": "KG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Uzbekistan",<br />"Code": "UZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Chile",<br />"Code": "CL",<br />"Region": "US"<br />},<br />{<br />"Value": "Austria",<br />"Code": "AT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Liberia",<br />"Code": "LR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Macedonia",<br />"Code": "MK",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Brazil",<br />"Code": "BR",<br />"Region": "US"<br />},<br />{<br />"Value": "Uganda",<br />"Code": "UG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Malaysia",<br />"Code": "MY",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Poland",<br />"Code": "PL",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Malta",<br />"Code": "MT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Japan",<br />"Code": "JP",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Madagascar",<br />"Code": "MG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Nepal",<br />"Code": "NP",<br />"Region": "APJ"<br />},<br />{<br />"Value": "French Polynesia",<br />"Code": "PF",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Honduras",<br />"Code": "HN",<br />"Region": "US"<br />},<br />{<br />"Value": "Samoa",<br />"Code": "WS",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Tajikistan",<br />"Code": "TJ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Lebanon",<br />"Code": "LB",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Maldives",<br />"Code": "MV",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Cyprus",<br />"Code": "CY",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Latin America &amp; Caribbean",<br />"Code": "LA",<br />"Region": "US"<br />},<br />{<br />"Value": "Oman",<br />"Code": "OM",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Taiwan",<br />"Code": "TW",<br />"Region": "APJ"<br />},<br />{<br />"Value": "Mexico",<br />"Code": "MX",<br />"Region": "US"<br />},<br />{<br />"Value": "Nigeria",<br />"Code": "NG",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bahrain",<br />"Code": "BH",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Tanzania",<br />"Code": "TZ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Cayman Islands",<br />"Code": "KY",<br />"Region": "US"<br />},<br />{<br />"Value": "Grenada",<br />"Code": "GD",<br />"Region": "US"<br />},<br />{<br />"Value": "Gabon",<br />"Code": "GA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Portugal",<br />"Code": "PT",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Bosnia-Herzegovina",<br />"Code": "BA",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Moldova",<br />"Code": "MD",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Libya",<br />"Code": "LY",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Jordan",<br />"Code": "JO",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "France",<br />"Code": "FR",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Senegal",<br />"Code": "SN",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Iraq",<br />"Code": "IQ",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Netherlands Antilles\\/Curacao",<br />"Code": "AN",<br />"Region": "US"<br />},<br />{<br />"Value": "Burundi",<br />"Code": "BI",<br />"Region": "EMEA"<br />},<br />{<br />"Value": "Panama",<br />"Code": "PA",<br />"Region": "US"<br />}<br />]',
    },
  },
  {
    key: "ptc_lst_removal_add_another_address",
    value: {
      microContentValue: "Add Another Street Address Field",
    },
  },
  {
    key: "ptc_lst_removal_add_extension_label",
    value: {
      microContentValue: "Add Extension",
    },
  },
  {
    key: "ptc_lst_removal_add_suggest",
    value: {
      microContentValue: "Address Suggestions",
    },
  },
  {
    key: "ptc_lst_removal_address_line_2",
    value: {
      microContentValue: "Address Line {0}",
    },
  },
  {
    key: "ptc_lst_removal_bussiness_days",
    value: {
      microContentValue: "10",
    },
  },
  {
    key: "ptc_lst_removal_cancel_button",
    value: {
      microContentValue: "Cancel",
    },
  },
  {
    key: "ptc_lst_removal_city_label",
    value: {
      microContentValue: "City",
    },
  },
  {
    key: "ptc_lst_removal_company_name_label",
    value: {
      microContentValue: "Company Name",
    },
  },
  {
    key: "ptc_lst_removal_country_label",
    value: {
      microContentValue: "Country",
    },
  },
  {
    key: "ptc_lst_removal_email_address_label",
    value: {
      microContentValue: "E-mail Address",
    },
  },
  {
    key: "ptc_lst_removal_email_checkbox",
    value: {
      microContentValue: "Email",
    },
  },
  {
    key: "ptc_lst_removal_fax_checkbox",
    value: {
      microContentValue: "Fax",
    },
  },
  {
    key: "ptc_lst_removal_fax_number_label",
    value: {
      microContentValue: "Fax Number",
    },
  },
  {
    key: "ptc_lst_removal_first_name_label",
    value: {
      microContentValue: "First Name",
    },
  },
  {
    key: "ptc_lst_removal_footer_content",
    value: {
      microContentValue:
        "Our records will be updated to reflect your request. Please allow us up to {0} business days for email, and up to {1} for direct mail for your preferences to take effect. Since some communications, such as direct mail catalogues, are developed and queued for distribution well in advance, you may receive additional information after we have processed your request.",
    },
  },
  {
    key: "ptc_lst_removal_header",
    value: {
      microContentValue: "List Removal",
    },
  },
  {
    key: "ptc_lst_removal_header_content",
    value: {
      microContentValue:
        "",
    },
  },
  {
    key: "ptc_lst_removal_home_phone",
    value: {
      microContentValue: "Home Phone",
    },
  },
  {
    key: "ptc_lst_removal_last_name_label",
    value: {
      microContentValue: "Last Name",
    },
  },
  {
    key: "ptc_lst_removal_mobile_checkbox",
    value: {
      microContentValue: "Mobile",
    },
  },
  {
    key: "ptc_lst_removal_mobile_phone_label",
    value: {
      microContentValue: "Mobile Phone",
    },
  },
  {
    key: "ptc_lst_removal_months",
    value: {
      microContentValue: "3",
    },
  },
  {
    key: "ptc_lst_removal_phone_checkbox",
    value: {
      microContentValue: "Phone",
    },
  },
  {
    key: "ptc_lst_removal_postalmail_checkbox",
    value: {
      microContentValue: "Postal Mail",
    },
  },
  {
    key: "ptc_lst_removal_preference_management",
    value: {
      microContentValue: "",
    },
  },
  {
    key: "ptc_lst_removal_privacy_content",
    value: {
      microContentValue:
        "To learn more about how Dell protects your privacy, please visit our",
    },
  },
  {
    key: "ptc_lst_removal_privacy_statement",
    value: {
      microContentValue: "Privacy Statement",
    },
  },
  {
    key: "ptc_lst_removal_required_fields_content",
    value: {
      microContentValue:
        "Please note that if all information below is not provided, we may not be able to correlate all potential records related to you.",
    },
  },
  {
    key: "ptc_lst_removal_state_label",
    value: {
      microContentValue: "State",
    },
  },
  {
    key: "ptc_lst_removal_street_address_label",
    value: {
      microContentValue: "Street Address",
    },
  },
  {
    key: "ptc_lst_removal_unsubscribe_content",
    value: {
      microContentValue:
        "Please unsubscribe me from receiving the following Dell marketing communications.",
    },
  },
  {
    key: "ptc_lst_removal_unsubscribe_link",
    value: {
      microContentValue: "Unsubscribe",
    },
  },
  {
    key: "ptc_lst_removal_work_phone_label",
    value: {
      microContentValue: "Work Phone",
    },
  },
  {
    key: "ptc_lst_removal_zip_code_label",
    value: {
      microContentValue: "ZIP Code",
    },
  },
  {
    key: "ptc_list_failure",
    value: {
      microContentValue: "Failed to unsubscribe",
    },
  },
  {
    key: "ptc_lst_months_weeks",
    value: {
      microContentValue: "3 months",
    },
  },
  {
    key: "ptc_list_validate_sms",
    value: {
        microContentValue: "Please enter a valid SMS number",
    },
  },
  {
    key: "ptc_lst_removal_sms_checkbox",
    value: {
        microContentValue: "SMS",
    },
  },
  {
    key: "ptc_lst_removal_sms_number_label",
    value: {
        microContentValue: "SMS Number",
    },
  },
  {
    key: "ptc_lst_removal_whatsapp_checkbox",
    value: {
      microContentValue: "WhatsApp",
    },
  },
  {
    key: "ptc_lst_removal_phone_number_label",
    value: {
      microContentValue: "Phone Number",
    }
  }

];
